import { BasePagePath } from 'app/core/workflow/page-path/base-page.path';

export class BaseStatementPagePath extends BasePagePath {
  public static get prefix(): string {
    return 'new/';
  }
}
